import { useState, useEffect, useRef } from "react";
export default function ContactCTA() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section style={{
    backgroundColor: "rgb(255, 255, 255)",
    backgroundSize: "cover",
    backgroundPosition: "50% 50%",
    backgroundRepeat: "repeat",
    color: "rgb(102, 102, 102)",
    fontFamily: '"Open Sans", Arial, sans-serif',
    paddingTop: "20px",
    paddingBottom: "20px",
    position: "relative"
  }} className="![padding:5px_0px_20px_0px]">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600;700&display=swap');`}</style>
      <div className="page-container">
        <div ref={ref} className={`flex flex-col items-center transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="flex justify-center w-full mb-4">
            <h1 style={{
            fontFamily: '"Open Sans", Arial, sans-serif',
            fontSize: "23px",
            fontWeight: "700",
            lineHeight: "23px",
            border: "0px none rgb(255, 255, 255)",
            padding: "14px 40px 14px",
            textTransform: "uppercase",
            textAlign: "center",
            backgroundColor: "#CEC44E",
            color: "#FFFFFF",
            borderRadius: "100px",
            margin: "0px",
            letterSpacing: "0.04em",
            display: "inline-block"
          }} className="!bg-[rgba(0,70,84,1)] !text-xl">CONTACT US:</h1>
          </div>

          <p style={{
          color: "rgb(102, 102, 102)",
          fontFamily: '"Open Sans", Arial, sans-serif',
          fontSize: "14px",
          fontWeight: "500",
          lineHeight: "23.8px",
          border: "0px none rgb(102, 102, 102)",
          textAlign: "center",
          margin: "0px",
          maxWidth: "780px"
        }} className="!text-sm !font-sans">GET IN TOUCH WITH A REPRESENTATIVE FROM THE LEADS TODAY TO FIND OUT HOW WE CAN ASSIST YOUR OPERATIONS.<br /><div className="!h-[10px]" data-ast-id="f:/src/pages/Home/sections/ContactCta.tsx|sig:151k50" data-ast-start="2306" data-ast-end="2489" contenteditable="false" style={{}}><br /></div><div className="!font-black !font-sans !text-sm" data-ast-id="f:/src/pages/Home/sections/ContactCta.tsx|sig:vuijp9" data-ast-start="2489" data-ast-end="2717" contenteditable="false" style={{}}>PHONE: +27 (10) 061-1902<br /></div><div className="!font-black !text-sm" data-ast-id="f:/src/pages/Home/sections/ContactCta.tsx|sig:mk30sw" data-ast-start="2717" data-ast-end="2958" contenteditable="false"><br />ADDRESS: UNIT 2, ALBERT AMON ROAD, MEADOWDALE, GERMISTON, 1614</div></p>
        </div>
      </div>
    </section>;
}